<template>
    <CompassDialog
        class="activities-link-object"
        :visible.sync="showModal"
        :title="$t.__('activities.dialog.ActivitiesLinkObjectDialog.link_object_title')"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
        @closed="$emit('close')"
    >
        <SearchObjectToLinkComponent
            v-show="!objectSelected"
            :isVisible="!objectSelected"
            :emptyStateData="emptyStateData"
            @objectSelected="(value) => (objectSelected = value)"
        />
        <template v-if="objectSelected">
            <div
                class="typographies-paragraph-medium-semibold activities-link-object__selected-label"
            >
                {{ $t.__('activities.labels.selected_object') }}
            </div>
            <BlockCompany
                v-if="objectSelected.blockType === 'company'"
                :data="objectSelected.data"
                :showMobile="false"
                :showAddress="false"
                variant="linked"
                @unlink="objectSelected = null"
            />
            <BlockContact
                v-else-if="objectSelected.blockType === 'contact'"
                :data="objectSelected.data"
                :showPhone="false"
                variant="linked"
                @unlink="objectSelected = null"
            />
            <BlockDocument
                v-else-if="objectSelected.blockType === 'document'"
                :data="objectSelected.data"
                variant="linked"
                @unlink="objectSelected = null"
            />
            <BlockOpportunity
                v-else-if="objectSelected.blockType === 'opportunity'"
                :data="objectSelected.data"
                variant="linked"
                @unlink="objectSelected = null"
            />
            <BlockIndividual
                v-else-if="objectSelected.blockType === 'individual'"
                :data="objectSelected.data"
                variant="linked"
                @unlink="objectSelected = null"
            />
        </template>
    </CompassDialog>
</template>
<script>
import SearchObjectToLinkComponent from 'vcomponents/common/object/SearchObjectToLinkComponent.vue';
import BlockCompany from 'vcomponents/common/object/BlockCompany.vue';
import BlockIndividual from 'vcomponents/common/object/BlockIndividual.vue';
import BlockContact from 'vcomponents/common/object/BlockContact.vue';
import BlockDocument from 'vcomponents/common/object/BlockDocument.vue';
import BlockOpportunity from 'vcomponents/common/object/BlockOpportunity.vue';
import { getFullNameUser } from 'Helpers/avatarHelper.js';

export default {
    components: {
        SearchObjectToLinkComponent,
        BlockCompany,
        BlockContact,
        BlockDocument,
        BlockOpportunity,
        BlockIndividual,
    },
    props: {
        callback: {
            type: Function,
            default: null,
        },
        related: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            objectSelected: null,
            showModal: true,
            secondaryActions: [
                {
                    label: this.$t.__('common.actions.cancel'),
                    action: () => {
                        this.$emit('close');
                    },
                },
            ],
            emptyStateData: {
                title: this.$t.__(
                    'activities.dialog.SearchObjectToLinkComponent.empty_state_title',
                ),
                caption: this.$t.__(
                    'activities.dialog.SearchObjectToLinkComponent.empty_state_caption',
                ),
                illustrationPath: '/ressources/logged/img/illustrations/empty-activities.svg',
            },
        };
    },
    computed: {
        dataBotConfirm() {
            return `activities-link-object-confirm__${this.objectSelected?.blockType ?? ''}`;
        },
        primaryAction() {
            return {
                disabled: !this.objectSelected,
                label: this.$t.__('common.actions.confirm'),
                dataBot: this.dataBotConfirm,
                action: () => this.confirmLinkObject(),
            };
        },
    },
    created() {
        if (this.related) {
            this.objectSelected = {
                data: {
                    ...this.related,
                    type: this.related.subtype ?? this.related.type,
                },
                blockType: this.related.object,
            };
        }
    },
    methods: {
        confirmLinkObject() {
            if (this.callback) {
                let name = this.objectSelected.data.name;
                let type = this.objectSelected.blockType;
                if (['contact', 'individual'].includes(type)) {
                    name = getFullNameUser(this.objectSelected.data);
                } else if (type === 'document') {
                    name = this.objectSelected.data.number;
                    type = this.objectSelected.type;
                }
                let related = {
                    ...this.objectSelected.data,
                    object: this.objectSelected.blockType,
                    type,
                    name,
                    subtype: this.objectSelected.type,
                };
                if (this.objectSelected.item) {
                    related = {
                        ...related,
                        id: this.objectSelected.item.id,
                        link: this.objectSelected.item.link,
                        status: this.objectSelected.item?.status ?? null,
                    };
                }

                this.callback(related);
            }
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.activities-link-object {
    .object-block {
        width: 100%;
    }

    &__selected-label {
        margin-bottom: var(--spacing-0);
    }
}
</style>
